import axios from '../config/axiosConfig';

const API_URL = '/projects/';

// Get all projects
const getProjects = async () => {
  const response = await axios.get(API_URL);
  return response.data;
};

// Get single project
const getProject = async (id) => {
  const response = await axios.get(API_URL + id);
  return response.data;
};

// Create project
const createProject = async (projectData) => {
  const response = await axios.post(API_URL, projectData);
  return response.data;
};

// Update project
const updateProject = async (id, projectData) => {
  const response = await axios.put(API_URL + id, projectData);
  return response.data;
};

// Delete project
const deleteProject = async (id) => {
  const response = await axios.delete(API_URL + id);
  return response.data;
};

const projectService = {
  getProjects,
  getProject,
  createProject,
  updateProject,
  deleteProject,
};

export default projectService;